import { useContext, useCallback } from 'react';

import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';

const useSpinner = () => {
    const { dispatch } = useContext(Context);

    const showSpinner = useCallback(() => {
        dispatch({ type: REDUCERS.SHOW_SPINNER });
    }, [dispatch]);

    const hideSpinner = useCallback(() => {
        dispatch({ type: REDUCERS.HIDE_SPINNER });
    }, [dispatch]);

    return { showSpinner, hideSpinner };
};

export default useSpinner;
